import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
const GTM = () => {
    const DISABLE_GTM_FLAG = localStorage.getItem('DISABLE_GTM_FLAG');
    return (React.createElement(Fragment, null, !DISABLE_GTM_FLAG && (React.createElement(Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("script", { type: "text/javascript" }, `<!-- Google Tag Manager -->
        (function (w, d, s, l, i) {w[l] = w[l] || []; w[l].push({'gtm.start':
        new Date().getTime(), event: 'gtm.js'}); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-TZ5KBJS');
        <!-- End Google Tag Manager -->`),
            React.createElement("script", { type: "text/javascript" }, `<!-- Anti-flicker -->
        (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
        h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
        (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
        })(window,document.documentElement,'async-hide','dataLayer',4000,
        {'GTM-TZ5KBJS':true});
        <!-- End of Anti-flicker -->`)),
        React.createElement("noscript", null,
            React.createElement("iframe", { title: "GTM", src: "https://www.googletagmanager.com/ns.html?id=GTM-TZ5KBJS", height: "0", width: "0", style: { display: 'none', visibility: 'hidden' } }))))));
};
export default GTM;
